@if (viewModels && viewModels.length > 0) {
  <ng-container [ngTemplateOutlet]="content"></ng-container>
} @else {
  <ng-container [ngTemplateOutlet]="spinner"></ng-container>
}
<!-- CONTENT -->
<ng-template #content>
  <h2 class="h3 mb-0 py-2" [ngClass]="{ 'text-center': isMobileWidth() }">
    <div class="row">
      <span data-e2e="item-title" class="col-12 item-title">{{
        'dashboard.forbidden.sharedServices.activeTitle' | translate
      }}</span>
    </div>
  </h2>
  @for (item of viewModels; track item; let last = $last) {
    @if (isMobileWidth()) {
      <ng-container [ngTemplateOutlet]="mobile" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
    } @else {
      <ng-container [ngTemplateOutlet]="desktop" [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
    }
  }
</ng-template>
<!-- DESKTOP CONTENT -->
<ng-template #desktop let-item>
  <div class="row no-gutters">
    <div class="col-3 align-self-center text-center">
      <img data-e2e="item-img" alt="" class="img-fluid dashboard-item-img" [src]="item.imgUrl" />
    </div>
    <div class="col-9 pl-3 align-self-center">
      <a
        class="items-list-item dashboard-item-pos"
        [attr.data-e2e]="'e2e-shared-services-' + item?.name"
        (click)="openLink(item.link, item.type); (false)"
        [ecmDisabledAction]="true"
        [href]="linkService.getLinkSync(item?.link)"
      >
        <div class="item-container">
          <div class="item-text">
            <span class="lead p-0"
              ><strong>{{ item.name }}</strong></span
            >
            <small class="item-desc lead pb-1">{{ item.description }}</small>
          </div>
        </div>
      </a>
    </div>
  </div>
</ng-template>

<!-- MOBILE CONTENT -->
<ng-template #mobile let-item>
  <div class="row">
    <div class="col-12">
      <ul class="items-list row">
        <li class="col-12">
          <a
            class="items-list-item dashboard-item-pos"
            [attr.data-e2e]="'e2e-shared-services-' + item?.name"
            (click)="openLink(item.link, item.type); (false)"
            [ecmDisabledAction]="true"
            [href]="this.linkService.getLinkSync(item?.link)"
          >
            <div class="item-container dashboard-anchor">
              <div class="item-text align-self-baseline">
                <span class="lead pt-0"
                  ><strong>{{ item.name }}</strong></span
                >
                <small class="item-desc">{{ item.description }}</small>
              </div>
              <div class="ml-auto align-self-end">
                <img data-e2e="item-img" alt="" class="img-fluid dashboard-item-img" src="{{ item.imgUrl }}" />
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</ng-template>
<!-- SPINNER -->
<ng-template #spinner>
  <section class="apply-one-style" aria-label="Synthèse de l'offre">
    <div class="py-5">
      <ecm-mat-spinner [centered]="true"></ecm-mat-spinner>
    </div>
  </section>
</ng-template>
